import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { 
  getToken, 
  // getIsAdminLogin 
} from "./Utils/Common";

import './App.css';
import './CssFiles/CommonStyle.css';
import './CssFiles/CustomStyle.css';
import './CssFiles/Responsiveness.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from "./Page/Login/Login";
import Invitational from "./Page/ViewInvitational/Invitational";
import FourManThreeCountInvitational from "./Page/FourManThreeCount/FourManThreeCountInvitational";
import FourManThreeCountPlayer from "./Page/FourManThreeCount/FourManThreeCountPlayer";
import FourManThreeCountScoreCard from "./Page/FourManThreeCount/FourManThreeCountScoreCard";
import FourManThreeCountViewSummary from "./Page/FourManThreeCount/FourManThreeCountViewSummary";
import FunGolf from "./Page/FunGolf/FunGolf";
import FunGolfPlayer from "./Page/FunGolf/FunGolfPlayer";
import FunGolfScoreCard from "./Page/FunGolf/FunGolfScoreCard";
import FunGolfViewSummary from "./Page/FunGolf/FunGolfViewSummary";
import Player from "./Page/ViewInvitational/InvitationalPlayer";
import ScoreCard from "./Page/ViewInvitational/InvitationalScoreCard";
import IndividualStrokeplay from "./Page/IndividualStrokeplay/IndividualStrokeplay";
import IndividualPlayer from "./Page/IndividualStrokeplay/Player";
import IndividualScoreCard from "./Page/IndividualStrokeplay/ScoreCard";
import ViewSummary from "./Page/ViewInvitational/InvitationalViewSummary";
import { Toaster } from 'react-hot-toast';
import System36IndividualGame from "./Page/System36/IndividualGame/System36IndividualGame";
import System36TeamGame from "./Page/System36/TeamGame/System36TeamGame";
import TwoManBestBall from "./Page/TwoManBestBall/TwoManBestBall";
import TwoManBestBallPlayer from "./Page/TwoManBestBall/TwoManBestBallPlayer";
import TwoManBestBallScoreCard from "./Page/TwoManBestBall/TwoManBestBallScoreCard";
import TwoManBestBallViewSummary from "./Page/TwoManBestBall/TwoManBestBallViewSummary";

function App() {
  const userToken = getToken();
  // const isAdmin = getIsAdminLogin();

  const toastOptions = {
    duration: 3000,
    style: {
      fontFamily: 'var(--font-regular)',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.9)', 
      color: '#fff', 
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out', 
    },
    success: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(65, 184, 131, 0.9)', 
      },
    },
    error: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(255, 99, 71, 0.9)', 
      },
    },
  };

  return (
    <div className="page">
      <Toaster position="top-right" toastOptions={toastOptions} />
      <Router>
        <Routes>
          <Route path="/" element={userToken ? <Invitational/> : <Login/>}/>
          <Route path="/invitational" element={userToken ? <Invitational/> : <Login/>}/>
          <Route path="/invitational/player/:id" element={userToken ? <Player/> : <Login/>}/>
          <Route path="/invitational/scorecard" element={userToken ? <ScoreCard/> : <Login/>}/>
          <Route path="/invitational/scorecard/:id/:member_id?" element={userToken ? <ScoreCard/> : <Login/>}/>
          <Route path="/invitational/summary/:id" element={userToken ? <ViewSummary/> : <Login/>}/>
          
          <Route path="/fourman" element={userToken ? <FourManThreeCountInvitational/> : <Login/>}/>
          <Route path="/fourman/player/:id" element={userToken ? <FourManThreeCountPlayer/> : <Login/>}/>
          <Route path="/fourman/scorecard" element={userToken ? <FourManThreeCountScoreCard/> : <Login/>}/>
          <Route path="/fourman/scorecard/:id" element={userToken ? <FourManThreeCountScoreCard/> : <Login/>}/>
          <Route path="/fourman/summary/:id" element={userToken ? <FourManThreeCountViewSummary/> : <Login/>}/>

          <Route path="/fun-golf" element={userToken ? <FunGolf/> : <Login/>}/>
          <Route path="/fun-golf/player/:id" element={userToken ? <FunGolfPlayer/> : <Login/>}/>
          <Route path="/fun-golf/scorecard" element={userToken ? <FunGolfScoreCard/> : <Login/>}/>
          <Route path="/fun-golf/scorecard/:id" element={userToken ? <FunGolfScoreCard/> : <Login/>}/>
          <Route path="/fun-golf/summary/:id" element={userToken ? <FunGolfViewSummary/> : <Login/>}/>

          <Route path="/best-ball" element={userToken ? <TwoManBestBall/> : <Login/>}/>
          <Route path="/best-ball/player/:id" element={userToken ? <TwoManBestBallPlayer/> : <Login/>}/>
          <Route path="/best-ball/scorecard" element={userToken ? <TwoManBestBallScoreCard/> : <Login/>}/>
          <Route path="/best-ball/scorecard/:id" element={userToken ? <TwoManBestBallScoreCard/> : <Login/>}/>
          <Route path="/best-ball/summary/:id" element={userToken ? <TwoManBestBallViewSummary/> : <Login/>}/>


          <Route path="/individualstrokeplay" element={userToken ? <IndividualStrokeplay/> : <Login/>}/>
          <Route path="/individualstrokeplay/player/:id" element={userToken ? <IndividualPlayer/> : <Login/>}/>
          <Route path="/individualstrokeplay/scorecard" element={userToken ? <IndividualScoreCard/> : <Login/>}/>
          <Route path="/system36individual" element={userToken ? <System36IndividualGame/> : <Login/>}/>
          <Route path="/system36team" element={userToken ? <System36TeamGame/> : <Login/>}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
